<template>
  <div class="card card-user">
    <div class="image" />
    <div class="card-body">
      <div class="author">
        <h5 class="title">
          {{ person.name }}
        </h5>
        <p class="description">
          School Year: {{ person.school_year }}
        </p>
        <p class="description">
          {{ person.primary_location }}
        </p>
        <p class="description">
          {{ person.email }}<span v-if="person.email && person.email2"> (primary)</span>
        </p>
        <p v-if="person.email2" class="description">
          {{ person.email2 }}<span v-if="person.email && person.email2"> (secondary)</span>
        </p>
        <p class="description">
          <b>Phone: </b>{{ person.phone }}
        </p>
        <p class="description" v-if="person.is_greek">
          Greek
        </p>
        <p class="description" v-if="person.is_varsity">
          Varsity Athlete
        </p>
        <p class="description" v-if="!person.can_be_reminded_to_login && isOneOfTheseRoles(['td','missionary'])">
          <small>
            *The "Send Invite Email" button only appears for students in
            <i>commissioned</i> discipleship who have not logged in yet.
          </small>
        </p>
        <p class="description" v-if="isOneOfTheseRoles(['admin'])">
          <b>OneLogin Email:</b> {{ person.user_email }}
        </p>
        <p-button
          type="default"
          outline
          round
          @click="handleSend()"
          v-if="person.can_be_reminded_to_login"
        >
          <i
            class="
          nc-icon
          nc-email-85"
          />
          Send Invite Email
        </p-button>
        <p-button
          type="default"
          outline
          round
          @click="generateLink()"
          v-if="person.can_be_reminded_to_login && isOneOfTheseRoles(['admin']) && !linkExists"
        >
          Generate Invite Link
        </p-button>
        <p class="description" v-if="linkExists">
          {{ link }}
        </p>
        <br>
        <p-button
          type="default"
          outline
          round
          @click="handleEdit()"
          v-if="person.can_be_edited_by_user"
        >
          <i
            class="
          el-icon-edit
          el-icon--left"
          /> Edit
        </p-button>
      </div>
    </div>
    <!-- <div class="card-footer">
      <hr>
      <div class="button-container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-6 ml-auto">
            <h5>
              12
              <br>
              <small>Files</small>
            </h5>
          </div>
          <div class="col-lg-4 col-md-6 col-6 ml-auto mr-auto">
            <h5>
              2GB
              <br>
              <small>Used</small>
            </h5>
          </div>
          <div class="col-lg-3 mr-auto">
            <h5>
              24,6$
              <br>
              <small>Spent</small>
            </h5>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { RepositoryFactory } from '../../repositories/repositoryFactory';
import apiService from '../../repositories/apiService';

const PeopleRepository = RepositoryFactory.get('people');

export default {
    data() {
        return {
            link: null
        };
    },
    computed: {
        linkExists() { return this.link != null; },
    },
    methods: {
        handleEdit() {
            this.$router.push({ name: 'PersonEdit', params: { id: this.$route.params.id } });
        },
        generateLink() {
            this.link = 'Loading...';
            PeopleRepository.generateInviteLink(this.person.id)
                .then((response) => {
                    // console.log('mobiletree');
                    // console.log(response.data);
                    this.link = response.data.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                    this.$message(error.response.data);
                    this.link = null;
                });
        },
        handleSend() {
            return new Promise((resolve, reject) => {
                apiService
                    .post('/disciple/remindLogin', { person_id: this.person.id })
                    .then((response) => {
                        this.$message(response.data.message);
                        resolve();
                    })
                    .catch((error) => {
                        this.$message(error.response.data.message);
                    });
            });
        },
        goBack() {
            return this.$router.go(-1);
        }
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        person: Object
    },
    created() {

    }
};

</script>
<style>
h5 {
  color: #51cbce;
}
.nc-email-85 {
  font-size: 13px !important;
  padding-right: 3px;
}
.back-button {
  margin: 6px;
}
</style>
